// extracted by mini-css-extract-plugin
module.exports = {"Social":"social-module--Social--3xjJy","socialIcon":"social-module--socialIcon--OB9Xz"};